export enum SUPPORT_ACTION_TYPES {
  FETCH_ALL_DATA = "brand/FETCH_ALL_DATA",
  SET_DATA = "support/SET_DATA",
  SET_IS_LOADING = "support/SET_IS_LOADING",
}
